export default __webpack_public_path__ + "static/media/empty-shopping.1d595aba.gif";